import { WitaConnector } from '@/services/repository/connector'

import { Repo } from './UserAbilities.d'

const ROOT_URL = '/security/user-abilities'

export const UserAbilitiesRepository = {
  FindById: async ({ userId }: Repo.UserAbilities.FindById.Params) => {
    const url = ROOT_URL + `/${userId}`
    return await WitaConnector.get<Repo.UserAbilities.FindById.Response>(url)
  },
}
